import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/ClientProviders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/layout/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/layout/NavBar.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/globals.css");
